import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { useSignOutUser } from "../Apis/UserApi";
import { CreditDetails } from "../../Helper";

interface DataProfile {
  firstName: string;
  lastName: string;
  email: string;
  avatarUrl: string;
  isActived: boolean;
  joinDate: string;
  id: string;
  profilePictureURL: string;
  mode: string;
  isSigned: boolean;
  isSubscriped: boolean;
  hasAnySubscriptions?:boolean;
}
interface AvailablePackagesProps{
  annualSubscription:{
    checkoutUrl:string,
    price:number,
  },
  monthlySubscription:{
    checkoutUrl:string,
    price:number,
  },
  yearlySavings:number,
}
interface PopularQuestionsAnswersProps{
  question:string,
  answer:string,
}
export interface UserState {
  IsAuthenticated: boolean;
  User?: any;
  token?: string;
  IsRequestCompleted?: boolean;
  errorMessage?: string;
  darkMode?: boolean;
  userData?: DataProfile;
  userAvatar?: string;
  userPlan?: string;
  profilePictureURL?: string;
  isUserUpdatePicture?: boolean;
  isSubscribed?: boolean;
  paymentUrl?:string ;
  paymentCoast?:number | null ;
  hasAnySubscriptions?:boolean;
  endFreeTrialSubscriptionDate?: number | null;
  subscriptionStatus?: number | null;
  availablePackages?: AvailablePackagesProps;
  popularQuestionsAnswers?: PopularQuestionsAnswersProps[];
  PackageCredits?:CreditDetails[];
  AppSuiteCosts?:{
    Image:number;
    Video:number
  }
  UserCredits?:{
    credits: number,
    usedCredits:number 
  },
  messageErrorAppSuite?:string

}

interface SubscriptionStatus { 
  endAt: string,
  status: number
}

let initialState: UserState = {
  darkMode: true,
  IsAuthenticated: false,
  User: {},
  userData: {
    firstName: "",
    lastName: "",
    email: "",
    avatarUrl: "",
    isActived: true,
    joinDate: "",
    id: "",
    profilePictureURL: "",
    mode: "",
    isSigned: false,
    isSubscriped: false,
    hasAnySubscriptions:false,
  },
  userAvatar: "",
  userPlan: "Community",
  profilePictureURL: "",
  isUserUpdatePicture: false,
  isSubscribed: false,
  paymentUrl: "" ,
  paymentCoast: 0 ,
  hasAnySubscriptions:false,
  endFreeTrialSubscriptionDate: null,
  subscriptionStatus: null,
  availablePackages:{
    annualSubscription:{
      checkoutUrl:"",
      price:0,
    },
    monthlySubscription:{
      checkoutUrl:"",
      price:0,
    },
    yearlySavings:0,
  },
  popularQuestionsAnswers:[],
  PackageCredits:[],
  AppSuiteCosts:{
    Image:0,
    Video:0
  },
  UserCredits:{
    credits: 0,
    usedCredits:0 
  },
  messageErrorAppSuite:"",
};

var user = localStorage.getItem("user");
if (user) initialState = JSON.parse(user);

const UserSlice = createSlice({
  name: "UserSlice",
  initialState: initialState,
  reducers: {
    authenticateUser: (state: UserState, action: PayloadAction<UserState>) => {
      state.IsAuthenticated = action.payload.IsAuthenticated;
      state.IsRequestCompleted = true;
      state.User = action.payload.User;
      state.errorMessage = "";
      localStorage.setItem("user", JSON.stringify(state));
    },

    signoutUserSuccess: (state: UserState) => {
      state.IsAuthenticated = false;
      state.isSubscribed = false;
      state.userData ={
        firstName: "",
        lastName: "",
        email: "",
        avatarUrl: "",
        isActived: true,
        joinDate: "",
        id: "",
        profilePictureURL: "",
        mode: "",
        isSigned: false,
        isSubscriped: false,
        hasAnySubscriptions: false,
      };
      state.errorMessage = "";
      state.token = "";
      localStorage.removeItem("user");
      localStorage.removeItem("confirmUserEmail");
      localStorage.removeItem("userEmail");
    },

    signoutUserFailed: (state: UserState, action: PayloadAction<UserState>) => {
      state.IsAuthenticated = false;
      state.errorMessage = action.payload.errorMessage;
      localStorage.removeItem("user");
      // localStorage.setItem("user", JSON.stringify(state));
    },

    signinUserSuccess: (state: UserState, action: PayloadAction<UserState>) => {
      state.IsAuthenticated = action.payload.IsAuthenticated;
      state.IsRequestCompleted = true;
      state.token = action.payload.token;
      state.errorMessage = "";
      state.profilePictureURL = action.payload.userData?.profilePictureURL;
      state.userData = action.payload.userData;
      state.isSubscribed=action.payload.userData?.isSubscriped;
      state.hasAnySubscriptions = action.payload.userData?.hasAnySubscriptions;
      // setProfilePictureURL(action.payload.userData?.profilePictureURL);
      localStorage.setItem("user", JSON.stringify(state));
      localStorage.removeItem("confirmUserEmail");
      localStorage.removeItem("prevPath");
    },
    
    changeSubscriptionStatus: (state: UserState, action: PayloadAction<boolean>) => {
      state.isSubscribed = action.payload;
      localStorage.setItem("user", JSON.stringify(state));
    },

    signinUserFailed: (state: UserState, action: PayloadAction<UserState>) => {
      state.IsAuthenticated = false;
      state.IsRequestCompleted = true;
      state.errorMessage = action.payload.errorMessage;
      localStorage.removeItem("user");
      localStorage.setItem("user", JSON.stringify(state));
    },
    forgetPasswordFailed: (state: UserState, action: PayloadAction<string>) => {
      state.errorMessage = action.payload;
    },
    setAppSuiteCosts: (state: UserState, action: PayloadAction<{Image:number;Video:number}>) => {
      state.AppSuiteCosts = action.payload;
    },
    setMessageErrorAppSuite: (state: UserState, action: PayloadAction<string>) => {
      state.messageErrorAppSuite = action.payload;
    },
    registerFailed: (state: UserState, action: PayloadAction<UserState>) => {
      state.IsRequestCompleted = true;
      state.errorMessage = action.payload.errorMessage;
    },
    toggleThemeMode: (state: UserState, action: PayloadAction<boolean>) => {
      state.darkMode = action.payload;
      localStorage.setItem("user", JSON.stringify(state));
      if (state.darkMode) {
        document.querySelector("body")?.setAttribute("color-theme", "dark");
      } else {
        document.querySelector("body")?.setAttribute("color-theme", "light");
      }
    },
    setAnonymousToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
      localStorage.setItem("user", JSON.stringify(state));
    },
    setUserAvatar: (state, action: PayloadAction<string>) => {
      state.userAvatar = action.payload;
    },
    setPackageCredits: (state, action: PayloadAction<CreditDetails[]>) => {
      state.PackageCredits = action.payload;
    },
    setUserCredits: (state, action: PayloadAction<{credits: number;usedCredits:number}>) => {
      state.UserCredits = action.payload;
    },
    setIsUserWithProPlan: (state, action: PayloadAction<string>) => {
      state.userPlan = action.payload;
    },
    setProfilePictureURL: (
      state,
      action: PayloadAction<string | undefined>
    ) => {
      state.profilePictureURL = action.payload;
    },
    setIsUpdateProfilePicture: (state, action: PayloadAction<boolean>) => {
      state.isUserUpdatePicture = action.payload;
    },
    setUpdateUserName: (
      state,
      action: PayloadAction<{ firstName: string; lastName: string }>
    ) => {
      if (state.userData) {
        state.userData.firstName = action.payload.firstName;
        state.userData.lastName = action.payload.lastName;
        localStorage.setItem("user", JSON.stringify(state));
      }
    },
    setPaymentLink: (state, action: PayloadAction<string | undefined>) => {
        state.paymentUrl = action.payload;
    },
    setAvailablePackages: (state, action: PayloadAction<AvailablePackagesProps>) => {
      state.availablePackages = {
        ...action.payload,
        annualSubscription: {
          ...action.payload.annualSubscription,
          price: action.payload.annualSubscription.price / 100,
        },
        monthlySubscription: {
          ...action.payload.monthlySubscription,
          price: action.payload.monthlySubscription.price / 100,
        },
        yearlySavings: Math.abs(action.payload.yearlySavings) / 100,
      };
   },
   setPopularQuestionsAnswers: (state, action: PayloadAction<PopularQuestionsAnswersProps[]>) => {
    state.popularQuestionsAnswers = action.payload;
   },
    setPaymentCost: (state, action: PayloadAction<number | null>) => {
        state.paymentCoast = action.payload;
    },
    setSubscriptionStatus: (state, action: PayloadAction<SubscriptionStatus>)=> {
      const targetDate = new Date(action.payload.endAt);
      const currentDate = new Date();
      
       // Calculate the difference in time
      const timeDifference = targetDate.getTime() - currentDate.getTime();
      
      // Calculate days remaining
      const daysRemaining = Math.floor(timeDifference / (1000 * 3600 * 24));

      // Set the state
      state.endFreeTrialSubscriptionDate = daysRemaining;
      state.subscriptionStatus = action.payload.status;
    }
  },
});

export const authenticateUserAsync =
  (payload: UserState) => (dispatch: any) => {
    dispatch(authenticateUser(payload));
  };

// export const updateUserPicture =
//   (userId: string, pictureUrl: ArrayBuffer | null) => (dispatch: any) => {
//     Api.post(`/account/updatePicture/${userId}`, {
//       file: pictureUrl,
//     })
//       .then((res) => {
//       })
//       .catch((e) => {
//       });
//   };

export const {
  authenticateUser,
  signoutUserSuccess,
  signoutUserFailed,
  signinUserSuccess,
  signinUserFailed,
  forgetPasswordFailed,
  registerFailed,
  toggleThemeMode,
  setAnonymousToken,
  setUserAvatar,
  setIsUserWithProPlan,
  setIsUpdateProfilePicture,
  setProfilePictureURL,
  setUpdateUserName,
  changeSubscriptionStatus,
  setPaymentLink,
  setPaymentCost,
  setAvailablePackages,
  setPopularQuestionsAnswers,
  setSubscriptionStatus,
  setPackageCredits,
  setUserCredits,
  setMessageErrorAppSuite,
  setAppSuiteCosts
} = UserSlice.actions;
export default UserSlice.reducer;